import { allRoles, administratorRoles } from "../config/roles";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/contact";

/**
 * The contacts list. Paged by the search endpoint, so nothing is read until a filter is
 * submitted - carried over from the legacy table, where a first read of every contact
 * was never on the cards.
 *
 * Column keys are the service's own field names, which is what makes a key usable as
 * the field to sort by.
 */
export const contactsListDefinition: ListDefinition = {
  path: "/contacts",
  entityName: "contact",
  recordRoute,
  title: "Contacts",
  allowedRoles: allRoles,
  data: "search-paged",
  // The same five the legacy contacts search offered. `contactSearchFilterArray` is
  // deliberately not reused: it is shared with the account and marketing-list
  // add-record tables, and it carries the legacy controls' own shape.
  //
  // Email address and the two names are what a search starts from; the rest sit behind
  // Advanced filters.
  filters: [
    {
      name: "emailaddress1",
      label: "Email Address",
      kind: "text",
      width: "wider",
      helpText: "Must be an exact match.",
    },
    { name: "firstname", label: "First Name", kind: "text" },
    { name: "lastname", label: "Last Name", kind: "text" },
    // First behind the toggle, because it only changes how the two names match.
    {
      name: "usesoundex",
      label: "Use Sounds Like",
      kind: "boolean",
      advanced: true,
    },
    {
      name: "createdon",
      label: "Created",
      kind: "date-range",
      advanced: true,
    },
  ],
  filterByStatus: true,
  allowAdd: true,
  addRoles: administratorRoles,
  allowStatusEdit: true,
  statusRoles: administratorRoles,
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 250,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      key: "firstname",
      label: "First Name",
      width: 200,
      sortable: true,
    },
    {
      key: "lastname",
      label: "Last Name",
      width: 200,
      sortable: true,
    },
    {
      key: "emailaddress1",
      label: "Email Address",
      width: 400,
      sortable: true,
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
